import {
  ADD_ATTENDENCE,
  UPDATE_ATTENDENCE,
  DELETE_ATTENDENCE,
  GET_ATTENDENCE,
} from "../type";
import { InsertData, InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateAttendenceAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/Attendance`, data);
    dispatch({
      type: ADD_ATTENDENCE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_ATTENDENCE,
      payload: "Error" + e,
    });
  }
};
export const GetAllAttendenceAction = (body) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Attendance?${body}`);
    dispatch({
      type: GET_ATTENDENCE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_ATTENDENCE,
      payload: "Error" + e,
    });
  }
};
export const UpdateAttendenceAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Attendance`, body);
    dispatch({
      type: UPDATE_ATTENDENCE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_ATTENDENCE,
      payload: "Error" + e,
    });
  }
};

export const DeleteAttendenceAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Attendance?id=${Id}`);
    dispatch({
      type: DELETE_ATTENDENCE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_ATTENDENCE,
      payload: "Error" + e,
    });
  }
};
